<template>
  <!-- 新绑定银行卡短信验证 -->
  <div>
    <Modal
      class="bind-modal"
      v-model="isShowPayPss"
      @on-cancel="cancel"
      width="400"
    >
      <p
        slot="header"
        style="color: #3280bf; text-align: left"
      >
        <span>安全验证</span>
      </p>
      <div>
        <Form :label-width="60">
          <FormItem
            label="短信验证码"
            class="must"
          >
            <Input
              v-model.trim="cardCode"
              class="form-input"
            ></Input>
            <span
              class="code-sty"
              @click="getCodeHandler"
              v-show="codeShow"
            >获取验证码</span>
            <span
              class="code-sty grey-sty"
              v-show="!codeShow"
            >{{ count }}s后重发</span>
          </FormItem>
        </Form>
      </div>
      <div
        slot="footer"
        style="text-align: center"
      >
        <Button
          style="width: 72px"
          type="error"
          size="large"
          long
          @click="saveBindHandle"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { payVerify } from "api/user.js";
export default {
  name: "payCardPassWord",
  props: {
    isShowPayCardModal: [Boolean],
    cusTraceNo: [String],
  },
  data() {
    return {
      isShowPayPss: this.isShowPayCardModal,
      cardCode: "",
      codeShow: true,
      count: "",
      isBindSuccess: false,
    };
  },
  watch: {
    isShowPayCardModal() {
      this.isShowPayPss = this.isShowPayCardModal;
    },
  },
  created() {},
  mounted() {
    let TIME_COUNT = 60;
    if (!this.timerCode) {
      this.count = TIME_COUNT;
      this.codeShow = false;
      this.timerCode = setInterval(() => {
        if (this.count > 0 && this.count <= TIME_COUNT) {
          this.count--;
        } else {
          this.codeShow = true;
          clearInterval(this.timerCode);
          this.timerCode = null;
        }
      }, 1000);
    }
  },

  methods: {
    // 获取验证码点击
    getCodeHandler() {
      this.$emit("getCode");
      let TIME_COUNT = 60;
      if (!this.timerCode) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timerCode = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timerCode);
            this.timerCode = null;
          }
        }, 1000);
      }
    },

    cancel() {
      clearInterval(this.timerCode);
      this.timerCode = null;
      this.$emit("update:isShowPayCardModal", false);
    },

    // 保存
    saveBindHandle() {
      if (!this.cardCode) {
        this.$Message.warning("请输入短信验证码");
        return;
      }
      console.log(this.cardCode, "44444444444444");
      if (!/^\d{6}$/.test(this.cardCode)) {
        this.$Message.warning("请输入正确的短信验证码");
      } else {
        const data = {
          origCusTraceNo: this.cusTraceNo,
          verifyCode: this.cardCode,
        };
        payVerify(data).then((res) => {
          if (res.resCode === 1) {
            this.$Message.success("支付成功");
            this.$emit("update:isShowPayCardModal", false);
            clearInterval(this.timerCode);
            this.timerCode = null;
            this.$router.push({ path: "/member/order" });
          } else {
            this.$Message.error(res.resDesc);
          }
        });
      }
    },
  },
};
</script>
<style lang="less">
.bind-modal {
  .box > .ivu-tabs > .ivu-tabs-bar {
    margin-bottom: 0 !important;
    border-bottom: none;
  }

  .form-input {
    width: 140px !important;
  }

  .form-input .ivu-input {
    height: 20px !important;
  }
}
.bind-modal {
  .ivu-form-item:before {
    display: inline-block;
    float: left;
    margin-top: 8px;
    height: 18px;
    width: 10px;
  }
  .must {
    display: flex;
    align-items: center;
  }
  .must:before {
    content: "*";
    color: red;
  }
  .ivu-form-item .ivu-form-item-label {
    color: #404040;
  }
  .ivu-form-item-content {
    margin-left: 0 !important;
    label {
      padding-left: 20px !important;
      color: #bbb;
    }
  }
  .ivu-modal-footer {
    text-align: center;
  }
  // .ivu-btn-long {
  //   width: auto;
  //   color: #404040;
  //   background-color: #f7f7f7;
  //   border-color: #dddee1;
  // }
  .ivu-btn-error:focus {
    box-shadow: none;
  }
  .code-sty {
    padding: 0 10px;
    display: inline-block;
    height: 28px;
    background: #67c23a;
    border-radius: 2px;
    color: #fff;
    margin-left: 20px;
    line-height: 28px;
    cursor: pointer;
  }
  .grey-sty {
    background: #ddd;
    color: rgba(0, 0, 0, 0.65);
  }
}
</style>



// WEBPACK FOOTER //
// payCardPassWord.vue?182404ef